import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=20745768&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20745768')) {
      api.createRecord('20745768', component.options)
    } else {
      api.reload('20745768', component.options)
    }
    module.hot.accept("./IconInfo.vue?vue&type=template&id=20745768&", function () {
      api.rerender('20745768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconInfo.vue"
export default component.exports